/* Wyld Chics: accessibility helpers (2026-10-19, after an axe-core WCAG 2.1 AA sweep of the live site).
   Carousels (Splide) keep loop clones and off-screen slides marked aria-hidden="true", but their links and
   buttons stay in the tab order, so keyboard users land on invisible copies (axe: aria-hidden-focus).
   Everything focusable inside an aria-hidden slide leaves the tab order, and gets its old tabindex back
   when the slide is shown again. */
(function () {
  'use strict';
  var FOCUSABLE = 'a[href], button, input, select, textarea, iframe, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';
  function sync(slide) {
    var hidden = slide.getAttribute('aria-hidden') === 'true';
    var nodes = slide.querySelectorAll(hidden ? FOCUSABLE : '[data-wc-a11y-tab]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (hidden) {
        if (!el.hasAttribute('data-wc-a11y-tab')) el.setAttribute('data-wc-a11y-tab', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
        el.setAttribute('tabindex', '-1');
      } else {
        var prev = el.getAttribute('data-wc-a11y-tab');
        if (prev === '') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', prev);
        el.removeAttribute('data-wc-a11y-tab');
      }
    }
  }
  function scan(root) {
    if (root.nodeType !== 1 && root !== document) return;
    if (root.classList && root.classList.contains('splide__slide')) sync(root);
    var slides = root.querySelectorAll('.splide__slide');
    for (var i = 0; i < slides.length; i++) sync(slides[i]);
  }
  var queued = [], timer = null;
  function flush() { timer = null; var list = queued; queued = []; for (var i = 0; i < list.length; i++) scan(list[i]); }
  function queue(node) { queued.push(node); if (!timer) timer = setTimeout(flush, 60); }
  function start() {
    scan(document);
    // apps inside a slide can put their own tabindex back later (Judge.me's star badge sets tabindex="0"
    // after it renders), and content can render into a slide after the first pass, so both re-sync the slide
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i], t = m.target;
        if (m.type === 'attributes') {
          if (m.attributeName === 'aria-hidden') { if (t.classList && t.classList.contains('splide__slide')) queue(t); }
          else if (t.getAttribute('tabindex') !== '-1' && t.closest) { var hs = t.closest('.splide__slide[aria-hidden="true"]'); if (hs) queue(hs); }
        } else {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j]; if (n.nodeType !== 1) continue;
            queue((n.closest && n.closest('.splide__slide')) || n);
          }
        }
      }
    }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden', 'tabindex'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
